import React from 'react';
import _ from 'lodash';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import InputButton from '../../../../../components/ZUILib/InputButton';
import TextInput from '../../../../../components/ZUILib/TextInput';
import Link from '../../../../../components/ZUILib/Link';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import * as typeActions from '../../actions';
import commonUtil from '../../../../../utils/commonUtil';

const { deleteBankOrCardDetails } = typeActions;
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

export default class UserCardBankCreate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      transferenceData: this.props.transferenceData.transferenceOptions,

      selectedDropdownAvailableCardsInfoValue: '',
      selectedRadioSavedCardsInfoValue: '',
      isNuevaCuentaButtonDisabled: false,

      isUserHasCards: false,
      isAddBankCard: false,
      isAddBankCardDetail: false,

      cardBankAmount: '',
      accountNumber: '',
      beneficiaryName: '',

      isNuevaCuentaDisabled: false,
    };
  }

  checkUpdateAmountField = (e, type) => {
    if (e) {
      const prevVal = this.state[e.target.name];
      /* eslint-disable */
      const regEx = type === 'backAmount' ? /^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/ :
        type === 'accountNumber' ? new RegExp('^[0-9]+$') : type === 'beneficiaryName' ? new RegExp('^[a-zA-Z ]*$') : null;
      /* eslint-enable */
      if (regEx.test(e.target.value)) {
        this.state[e.target.name] = e.target.value;
        this.setState({ [e.target.name]: e.target.value });
      } else {
        this.state[e.target.name] = prevVal;
        this.setState({ [e.target.name]: prevVal });
      }
    }
  }
  onBankAmountInputChange = (e) => {
    this.checkUpdateAmountField(e, 'backAmount');
    if ((this.state.cardBankAmount.length) > 0 && +this.state.cardBankAmount > 0 && +this.state.cardBankAmount < +this.state.transferenceData.transferableAmount) {
      if (this.state.transferenceData.savedCardsInfo && this.state.transferenceData.savedCardsInfo.length > 0) {
        this.setState({ isUserHasCards: true, isAddBankCard: false });
      } else {
        this.setState({ isUserHasCards: false, isAddBankCard: true });
      }
      if (this.state.selectedRadioSavedCardsInfoValue.length > 0) {
        this.props.disableContinueButton(false);
      } else {
        this.props.disableContinueButton(true);
      }
    } else {
      this.props.disableContinueButton(true);
      this.setState({ isUserHasCards: false, isAddBankCard: false });
    }
  }
  onAddCardInputChange = (e) => {
    if (e.target.name === 'accountNumber') {
      const regEx = new RegExp('^[0-9]+$');
      this.state[e.target.name] = regEx.test(e.target.value) ? e.target.value : '';
      this.setState({ [e.target.name]: regEx.test(e.target.value) ? e.target.value : '' });
      // this.checkUpdateAmountField(e, 'accountNumber');
    } else if (e.target.name === 'beneficiaryName') {
      this.checkUpdateAmountField(e, 'beneficiaryName');
    }
    if (this.state.accountNumber.length > 0 && this.state.beneficiaryName.length > 0) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  onEliminarButtonClick = () => {
    deleteBankOrCardDetails(this.state.selectedRadioSavedCardsInfoValue).then((res) => {
      if (res.body.status.status === 'success') {
        const transferenceData = this.state.transferenceData;
        _.remove(transferenceData.savedCardsInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue });
        this.setState({ transferenceData, selectedRadioSavedCardsInfoValue: '' });
        if (_.isEmpty(this.state.transferenceData.savedCardsInfo)) {
          this.setState({ isUserHasCards: false, isAddBankCard: true });
        }
      }
    });
  }

  onNuevaCuentaClick = () => {
    this.onFormCardAmountDivClick();
    this.setState({ isNuevaCuentaDisabled: true, isAddBankCard: true, selectedRadioSavedCardsInfoValue: '' });
    document.getElementById('radio_' + this.state.selectedRadioSavedCardsInfoValue).checked = false;
    this.props.disableContinueButton(true);
  }

  onFormCardAmountDivClick = () => {
    this.setState({ selectedRadioSavedCardsInfoValue: '' });
    if ((this.state.accountNumber && this.state.accountNumber.length > 0) && (this.state.beneficiaryName && this.state.beneficiaryName.length > 0)) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  handleRadioSelected = (data, e) => {
    this.setState({ selectedRadioSavedCardsInfoValue: e.target.value, accountNumber: '', beneficiaryName: '' });
    if (this.state.cardBankAmount.length > 0 && +this.state.cardBankAmount < +this.state.transferenceData.transferableAmount) {
      this.props.disableContinueButton(false);
    } else {
      this.props.disableContinueButton(true);
    }
  }

  onAvailableCardsInfoSelectChange = (data, e) => {
    this.setState({ selectedDropdownAvailableCardsInfoValue: e.target.value, isAddBankCardDetail: true, selectedRadioSavedCardsInfoValue: '' });
  }
  getFormData = () => {
    let reqParams = {};
    if (this.state.selectedRadioSavedCardsInfoValue === '') {
      const availableCardsObj = _.find(this.state.transferenceData.availableCardsInfo, { accountName: this.state.selectedDropdownAvailableCardsInfoValue });
      reqParams = {
        paymentType: availableCardsObj.accountName,
        commissionValue: availableCardsObj.commissionFee,
        cardOrBankAmount: this.state.cardBankAmount,
        number: this.state.accountNumber,
        accountName: this.state.beneficiaryName,
        totalAmount: this.state.transferenceData.transferableAmount,
      };
    } else {
      const savedCardsObj = _.find(this.state.transferenceData.savedCardsInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue });
      reqParams = {
        paymentType: savedCardsObj.accountType,
        commissionValue: '',
        cardOrBankAmount: this.state.cardBankAmount,
        cardOrBankIdentifierId: this.state.selectedRadioSavedCardsInfoValue,
        totalAmount: this.state.transferenceData.transferableAmount,
        cardNumber: savedCardsObj.accountNumber,
      };
    }
    return reqParams;
  }
  render() {
    const eliminarButtonJson = {
      name: 'Eliminar Tarjeta',
      type: 'button',
      autoFocus: false,
      classname: 'btnDelete size-Medium',
      cssStyle: { display: 'inline-grid' },
      value: 'Eliminar Tarjeta',
      onClickHandler: this.onEliminarButtonClick,
    };

    /* eslint-disable */
    const eliminarButton = (id) => {
      return (<span>
        {this.state.selectedRadioSavedCardsInfoValue === id ?
          <InputButton buttonAttr={{ ...eliminarButtonJson, id: ('eliminarButton_' + id) }} /> : null}
      </span>);
    };
    /* eslint-enable */

    const savedCardsInfo = {
      name: 'cardsInfo',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.savedCardsInfo) {
      this.state.transferenceData.savedCardsInfo.map(card =>
        savedCardsInfo.options.push({
          id: 'radio_' + card.accountId,
          value: card.accountId,
          displayName: <span>{card.accountType}</span>,
          subDetailsHTML: <p>{card.accountNumber}</p>,
          eliminarButton: eliminarButton(card.accountId),
          selected: false,
        }),
      );
    }

    const deleteJson = {
      onClickHandler: this.onEliminarButtonClick,
      cssClass: 'iClass icon-basura',
    };

    const nuevaCuentaButtonJson = {
      name: 'Nueva cuenta / tarjeta',
      type: 'button',
      autoFocus: false,
      classname: 'btnSecondarySpecial size-Medium',
      value: 'Nueva cuenta / tarjeta',
      onClickHandler: this.onNuevaCuentaClick,
      disabled: this.state.isNuevaCuentaDisabled,
    };

    const availableCardsInfo = {
      id: 'availableCardsInfoDropdown',
      optionCaption: 'Selecciona tipo de cuenta / Tarjeta',
      optionText: 'labelResourceId',
      optionValue: 'value',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.availableCardsInfo) {
      this.state.transferenceData.availableCardsInfo.map(card =>
        availableCardsInfo.options.push({
          /* eslint-disable */
          value: card.accountName,
          labelResourceId: +card.commissionFee !== 0 ? card.accountName + ' ' + '(' + card.commissionFee + '%' + ' ' + 'comisión' + ')' :
            card.accountName + ' ' + '(' + 'Sin' + ' ' + 'comisión' + ')',
          /* eslint-enable*/
        }),
      );
    }
    return (
      <div>
        {channel === constChannels.WAP ?
          <div className="innerForm display-block" id="option2">
            <div>
              <span className="inlineBlock">Disponible para retiro</span>&nbsp;&nbsp;
              <i className="iClass icon-ayuda display-inline-block tooltip-container">
                <span className="tooltip-box">
                  {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}</span>
              </i>
              <span className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</span>

              <div className="formBlock">
                <TextInput
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  label="Ingresa Cantidad a retirar"
                  required="true"
                  star="*"
                  onChange={this.onBankAmountInputChange}
                  name="cardBankAmount"
                  maxlength="10"
                  inputValue={this.state.cardBankAmount}
                  childElement={<small>Sr cobrará comisión por depósito a cuenta bancaria o tarjeta</small>}
                />
              </div>
            </div>
            {this.state.isUserHasCards ?
              <div className="display-block" id="blockAccount">
                <div className="col-xs-12">
                  <div>
                    <span className="titleForm">Selecciona la cuenta o tarjeta</span>
                    {savedCardsInfo.options.map((option, index) => (
                      <div className="row" key={index}>
                        <div className="col-xs-10">
                          <RadioButton checked={this.state.selectedRadioSavedCardsInfoValue === option.value} displayName={option.displayName} id={option.id} value={option.value} name="savedCardInfo" radioCssClass={'radio selectCard radioDF'} subDetailsHTML={option.subDetailsHTML} onChangeFunction={this.handleRadioSelected} />
                        </div>
                        <div className="col-xs-2 text-right trash"><Link linkJSON={deleteJson} />
                        </div>
                      </div>))}
                  </div>
                </div>
                <div>
                  <h4 className="card-title">Nueva tarjeta</h4>
                  <SelectionTab
                    classname="cSelect required"
                    id={availableCardsInfo.id}
                    options={availableCardsInfo.options}
                    optionCaption={'Selecciona tipo de cuenta / Tarjeta'}
                    optionText={'labelResourceId'}
                    optionValue={'value'}
                    handleSelectedOption={this.onAvailableCardsInfoSelectChange}
                    ref={cardSelectionPaymentType => this.cardSelectionPaymentType = cardSelectionPaymentType}
                  />
                  {this.state.isAddBankCardDetail ?
                    <div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Número de cuenta"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          maxlength="16"
                          name="accountNumber"
                          inputValue={this.state.accountNumber}
                          ref={txt => this.accountNumber = txt}
                        />
                      </div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Nombre del beneficiario"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          name="beneficiaryName"
                          maxlength="100"
                          inputValue={this.state.beneficiaryName}
                          ref={txt => this.beneficiaryName = txt}
                        />
                      </div>
                    </div>
                    : null}
                </div>
              </div>
              : null}
            {this.state.isAddBankCard ?
              <div className="display-block" id="blockNewAccount">
                <div className="col-xs-12+ offset-xs-8" onClick={this.onFormCardAmountDivClick}>

                  <SelectionTab
                    classname="cSelect required"
                    id={availableCardsInfo.id}
                    options={availableCardsInfo.options}
                    optionCaption={'Selecciona el banco de destino'}
                    optionText={'labelResourceId'}
                    optionValue={'value'}
                    handleSelectedOption={this.onAvailableCardsInfoSelectChange}
                    ref={cardSelectionPaymentType => this.cardSelectionPaymentType = cardSelectionPaymentType}
                  />
                  {this.state.isAddBankCardDetail ?
                    <div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Número de cuenta"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          maxlength="16"
                          name="accountNumber"
                          inputValue={this.state.accountNumber}
                          ref={txt => this.accountNumber = txt}
                        />
                      </div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Nombre del beneficiario"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          name="beneficiaryName"
                          maxlength="100"
                          inputValue={this.state.beneficiaryName}
                          ref={txt => this.beneficiaryName = txt}
                        />
                      </div>
                    </div>
                    : null}
                </div>
              </div>
              : null}
          </div>
          :
          // code foe web
          <div className="display-block" id="option2">
            <div className="row" >
              <div className="col-xs-4">
                <div className="formBlock">
                  <TextInput
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    label="Ingresa Cantidad a retirar"
                    required="true"
                    star="*"
                    onChange={this.onBankAmountInputChange}
                    name="cardBankAmount"
                    maxlength="10"
                    inputValue={this.state.cardBankAmount}
                    childElement={<small>Sr cobrará comisión por depósito a cuenta bancaria o tarjeta</small>}
                  />
                </div>
              </div>
              <div className="col-xs-4 offset-xs-4">
                <i className="iClass icon-ayuda tooltip-container">
                  <span className="tooltip-box">
                    {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.tooltip')}</span>
                </i><span> <small>&nbsp;&nbsp;Disponible para retiro</small></span>
                <div className="quantityBlock">
                  <strong className="quantity">{commonUtil.getCurrency(this.state.transferenceData.transferableAmount)}</strong>
                </div>
              </div>
            </div>
            {this.state.isUserHasCards ?
              <div className="row display-block" id="blockAccount">
                <div className="col-xs-7">
                  <div>
                    <span className="titleForm">Selecciona la cuenta o tarjeta</span>
                    {savedCardsInfo.options.map((option, index) => (
                      <div className="row" key={index}>
                        <div className="col-xs-7">
                          <RadioButton checked={this.state.selectedRadioSavedCardsInfoValue === option.value} displayName={option.displayName} id={option.id} value={option.value} name="savedCardInfo" radioCssClass={'radio selectCard radioDF'} subDetailsHTML={option.subDetailsHTML} onChangeFunction={this.handleRadioSelected} />
                        </div>
                        <div className="col-xs-5">
                          {option.eliminarButton}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-xs-2 col-xs-offset-3 display-block">
                  <InputButton buttonAttr={nuevaCuentaButtonJson} />
                </div>
              </div>
              : null}
            {this.state.isAddBankCard ?
              <div className="row display-block" id="blockNewAccount">
                <div className="col-xs-4 offset-xs-8" onClick={this.onFormCardAmountDivClick}>
                  <SelectionTab
                    classname="cSelect required"
                    id={availableCardsInfo.id}
                    options={availableCardsInfo.options}
                    optionCaption={'Selecciona el banco de destino'}
                    optionText={'labelResourceId'}
                    optionValue={'value'}
                    handleSelectedOption={this.onAvailableCardsInfoSelectChange}
                    ref={cardSelectionPaymentType => this.cardSelectionPaymentType = cardSelectionPaymentType}
                  />
                  {this.state.isAddBankCardDetail ?
                    <div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Número de cuenta"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          maxlength="16"
                          name="accountNumber"
                          inputValue={this.state.accountNumber}
                          ref={txt => this.accountNumber = txt}
                        />
                      </div>
                      <div className="formBlock">
                        <TextInput
                          className="inputMaterial"
                          labelClassName="placeHolderMaterial"
                          label="Nombre del beneficiario"
                          required="true"
                          star="*"
                          onChange={this.onAddCardInputChange}
                          name="beneficiaryName"
                          maxlength="100"
                          inputValue={this.state.beneficiaryName}
                          ref={txt => this.beneficiaryName = txt}
                        />
                      </div>
                    </div>
                    : null}
                </div>
              </div>
              : null}
          </div>}
      </div>
    );
  }
}
